import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import AdminLogin from './components/AdminLogin';
import Home from './pages/Home';
import PostDetail from './pages/PostDetail';
import CreatePost from './pages/CreatePost';
import TaskManager from './pages/TaskManager';
import './App.css';

function App() {
  const [showAdminLogin, setShowAdminLogin] = useState(false);

  const handleLoginSuccess = () => {
    setShowAdminLogin(false);
    // 刷新页面以更新管理员状态
    window.location.reload();
  };

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header onAdminLogin={() => setShowAdminLogin(true)} />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/post/:id" element={<PostDetail />} />
              <Route path="/create" element={<CreatePost />} />
              <Route path="/tasks" element={<TaskManager />} />
              <Route path="/admin/login" element={<AdminLogin />} />
            </Routes>
          </main>
          <Footer />
          
          {showAdminLogin && (
            <AdminLogin
              onLoginSuccess={handleLoginSuccess}
              onClose={() => setShowAdminLogin(false)}
            />
          )}
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;